import { isString } from 'lodash';
import type { PickDeep } from 'type-fest';
import { FleetCategory } from '../enums/fleet-category';
import type { Fleet } from '../interfaces/fleet';

export type FleetTypeIdentifier =
  | PickDeep<Fleet, 'generalInformation.category'>
  | Pick<Fleet['generalInformation'], 'category'>
  | FleetCategory;

export class FleetTypeHelper {
  public static isVehicle(fleet: FleetTypeIdentifier): boolean {
    return FleetTypeHelper.getType(fleet) === 'vehicle';
  }

  public static isTrailer(fleet: FleetTypeIdentifier): boolean {
    return FleetTypeHelper.getType(fleet) === 'trailer';
  }

  private static getType(
    typeIdentifier: FleetTypeIdentifier,
  ): 'vehicle' | 'trailer' {
    const category = isString(typeIdentifier)
      ? typeIdentifier
      : 'generalInformation' in typeIdentifier
        ? typeIdentifier.generalInformation.category
        : typeIdentifier.category;

    return (
      {
        [FleetCategory.SEMI_TRAILER]: 'trailer',
        [FleetCategory.SEMI_TRUCK]: 'vehicle',
        [FleetCategory.STRAIGHT_TRUCK]: 'vehicle',
        [FleetCategory.TRAILER]: 'trailer',
        [FleetCategory.VAN]: 'vehicle',
      } as const
    )[category];
  }
}
